import { Component, effect, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface SwitchOption {
    label: string;
    value: any;
}

@Component({
    selector: 'app-option-switch',
    templateUrl: './option-switch.component.html',
    styleUrls: ['./option-switch.component.scss'],
    imports: [TranslateModule],
})
export class OptionSwitchComponent {
    firstOption = input.required<SwitchOption>();
    secondOption = input.required<SwitchOption>();

    initialValue = input<any>();

    selectedValue = signal<any | undefined>(undefined);

    valueChanged = output<any>();

    constructor() {
        effect(() => {
            const initial = this.initialValue();
            if (initial) {
                this.selectedValue.set(initial);
            } else {
                this.selectedValue.set(this.firstOption().value);
            }
        });
    }

    selectOption(value: string) {
        this.selectedValue.set(value);
        this.valueChanged.emit(value);
    }
}
